import { render } from "./YesOrNo.vue?vue&type=template&id=639e499e"
import script from "./YesOrNo.vue?vue&type=script&lang=js"
export * from "./YesOrNo.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__